import { v4 as uuidv4 } from "uuid"

import people from "../../assets/images/groups.svg"
import factory from "../../assets/images/factory.svg"
import place from "../../assets/images/location_on.svg"
import bolt from "../../assets/images/bolt.svg"
import person from "../../assets/images/person_alone.svg"
import money from "../../assets/images/attach_money.svg"
import logistics from "../../assets/images/logistics.svg"
import gasMine from "../../assets/images/propane_tank.svg"
import worldIcon from "../../assets/images/public_blue.svg"

import {
    monterreyMetroplex,
    torreon,
    queretaroMetroplex,
    sanLuisPotosiMetroplex,
    ciudadJuarez,
    hermosillo,
    tijuana,
    guadalajaraMetroplex,
    saltillo,
    leon,
} from "../../utils/globalUtils.js"

const BORDER_CITY_OPTIONS = {
    // "Yes": [ciudadJuarez, tijuana],
    "No": [torreon, guadalajaraMetroplex, queretaroMetroplex, sanLuisPotosiMetroplex, leon],
    "LessThan500km": [ciudadJuarez, tijuana, monterreyMetroplex, hermosillo, saltillo ]
}

export const OPTION_INFO = [
    {
        id: uuidv4(),
        title: "Population range",
        accessKey: "population",
        image: people,
        options: [
            {
                id: uuidv4(),
                // title: "500,000 - 1,000,000",
                title: "+500,000",
                item: "500,000-1,000,000",
                min: 500000,
                max: 1000000
            },
            {
                id: uuidv4(),
                // title: "1,000,000 - 1,500,000",
                title: "+1,000,000",
                item: "1,000,000-1,500,000",
                min: 1000000,
                max: 1500000
            },
            {
                id: uuidv4(),
                // title: "1,500,000 - 5,000,000",
                title: "+1,500,000",
                item: "1,500,000-5,000,000",
                min: 1500000,
                max: 5000000
            },
            {
                id: uuidv4(),
                title: "+5,000,000",
                item: "+5000000",
                min: 5000000,
                max: 100000000
            },
        ],
        description: "Choose the desired Population range of the ideal city, to filter the data and focus on demographics that are most relevant to your analysis. This selection will influence the scope of the report."
    },
    {
        id: uuidv4(),
        title: "Economic Active Population",
        accessKey: "eap",
        image: money,
        options: [
            {
                id: uuidv4(),
                // title: "400,000 - 700,000",
                title: "+400,000",
                item: "400,000-700,000",
                min: 400000,
                max: 700000
            },
            {
                id: uuidv4(),
                // title: "700,000 - 1,000,000",
                title: "+700,000",
                item: "700,000-1,000,000",
                min: 700000,
                max: 1000000
            },
            {
                id: uuidv4(),
                // title: "1,000,000 - 3,000,000",
                title: "+1,000,000",
                item: "1,000,000-3,000,000",
                min: 1000000,
                max: 3000000
            },
            {
                id: uuidv4(),
                title: "+3,000,000",
                item: "+3000000",
                min: 3000000,
                max: 100000000
            },
        ],
        description: "Choose the desired Economic Active Population range of the ideal city, to filter the data and focus on demographics that are most relevant to your analysis. This selection may be narrowed based on the Population Selection and will impact the scope of the report.​"
    },
    {
        id: uuidv4(),
        title: "Workers/Operators",
        accessKey: "manningTable",
        image: person,
        options: [
            {
                id: uuidv4(),
                title: "Package 1 (0-50 operators)",
                item: "Package1",
            },
            {
                id: uuidv4(),
                title: "Package 2 (51-100 operators)",
                item: "Package2",
            },
            {
                id: uuidv4(),
                title: "Package 3 (101-200 operators)",
                item: "Package3",
            },
            {
                id: uuidv4(),
                title: "Package 4 (201-300 operators)",
                item: "Package4",
            },
            {
                id: uuidv4(),
                title: "Package 5 (301-500 operators)",
                item: "Package5",
            },
        ],
        description: "Select the closest number of operators that aligns with your ideal operation. This choice will determine the combination of administrative staff and other roles needed, allowing for an estimation of manning table costs in your report.​"
    },
    {
        id: uuidv4(),
        title: "Border city?",
        accessKey: "borderCity",
        image: logistics,
        options: [
            // {
            //     id: uuidv4(),
            //     title: "Yes",
            //     item: "Yes",
            // },
            {
                id: uuidv4(),
                title: "No",
                item: "No",
            },
            {
                id: uuidv4(),
                title: "Less than 500km",
                item: "LessThan500km",
            },
        ],
        description: "Select 'YES' for cities that border the U.S and 'NO' for cities without a U.S. border. This selection may be narrowed based on the Population Selection and will impact the scope of the report.​"
    },
    {
        id: uuidv4(),
        title: "Supplier location", //inbound
        accessKey: "supplierLocation",
        image: place,
        options: [
            {
                id: uuidv4(),
                title: "ASIA",
                item: "manzanilloPort",
            },
            {
                id: uuidv4(),
                title: "EUROPA",
                item: "altamiraPort",
            },
            {
                id: uuidv4(),
                title: "EAST US",
                item: "philadelphia",
            },
            {
                id: uuidv4(),
                title: "WEST US",
                item: "losAngeles",
            },
            {
                id: uuidv4(),
                title: "CENTER US",
                item: "austinTexas",
            },
        ],
        description: "Select the city that most closely matches the supplier's location where the raw material will be sent."
    },
    {
        id: uuidv4(),
        title: "Client location", //outbound
        accessKey: "clientLocation",
        image: place,
        options: [
            {
                id: uuidv4(),
                title: "ASIA",
                item: "manzanilloPort",
            },
            {
                id: uuidv4(),
                title: "EUROPA",
                item: "altamiraPort",
            },
            {
                id: uuidv4(),
                title: "EAST US",
                item: "philadelphia",
            },
            {
                id: uuidv4(),
                title: "WEST US",
                item: "losAngeles",
            },
            {
                id: uuidv4(),
                title: "CENTER US",
                item: "austinTexas",
            },
        ],
        description: "Select the city that most closely matches the client's location where the finished product will be delivered. This choice will influence the scope of the report​"
    },
    {
        id: uuidv4(),
        title: "Headquarters",
        accessKey: "headquarters",
        image: worldIcon,
        description: "Select the city that best aligns with the location of your company’s headquarters."
    },
    {
        id: uuidv4(),
        title: "Gas (monthly consumption)",
        accessKey: "gas",
        image: gasMine,
        options: [
            {
                id: uuidv4(),
                title: "Up to 50 gigajoules",
                item: "50gj",
            },
            {
                id: uuidv4(),
                title: "Up to 100 gigajoules",
                item: "100gj",
            },
            {
                id: uuidv4(),
                title: "Up to 500 gigajoules",
                item: "500gj",
            },
            {
                id: uuidv4(),
                title: "Up to 1,000 gigajoules",
                item: "1000gj",
            },
            {
                id: uuidv4(),
                title: "Up to 5,000 gigajoules",
                item: "5000gj",
            },
            {
                id: uuidv4(),
                title: "Up to 10,000 gigajoules",
                item: "10000gj",
            },
        ],
        description: "Select the monthly consumption range that most closely matches your operation. This choice will influence the scope of the report.​"
    },
    {
        id: uuidv4(),
        title: "Installed Electricity",
        accessKey: "electricityInstalled",
        image: bolt,
        options: [
            {
                id: uuidv4(),
                title: "Up to 500 KVA",
                item: "500KVA",
            },
            {
                id: uuidv4(),
                title: "Up to 1,000 KVA",
                item: "1,000KVA",
            },
            {
                id: uuidv4(),
                title: "Up to 2,000 KVA",
                item: "2,000KVA",
            },
        ],
        description: "Select the Installed Electricity range that most closely matches your operation. This choice will influence the scope of the report.​"
    },
    {
        id: uuidv4(),
        title: "Electricity consumption (monthly)",
        accessKey: "electricityConsumed",
        image: bolt,
        options: [
            {
                id: uuidv4(),
                title: "Up to 5,000 KWH",
                item: "5000KWH",
            },
            {
                id: uuidv4(),
                title: "Up to 100,000 KWH",
                item: "100,000KWH",
            },
            {
                id: uuidv4(),
                title: "Up to 500,000 KWH",
                item: "500,000KWH",
            },
            {
                id: uuidv4(),
                title: "Up to 800,000 KWH",
                item: "800,000KWH",
            },
        ],
        description: "Select the Monthly Electricity Consumption range that most closely matches your operation. This choice will influence the scope of the report.​"
    },
    {
        id: uuidv4(),
        title: "Facility size (sqft)",
        accessKey: "fabricSize",
        image: factory,
        options: [
            {
                id: uuidv4(),
                title: "< 50k",
                item: "lessThan50k",
            },
            {
                id: uuidv4(),
                title: "51k - 100k",
                item: "51k-100k",
            },
            {
                id: uuidv4(),
                title: "101k - 200k",
                item: "101k-200k",
            },
            {
                id: uuidv4(),
                title: "> 200k",
                item: "moreThan200k",
            },
        ],
        description: "Select the size of the facility (in square feet) that most closely matches your operation. This choice will influence the scope of the report.​"
    },
]

export function getEAPOptions(popRangeSelected, optionToCheck, teaserCities) {
    if (!popRangeSelected) return
    
    const optRangeSelected = OPTION_INFO.find(opt => opt.accessKey === "population").options.find(option => option.item === popRangeSelected)

    // const populationOfCities = teaserCities.filter(city => city.population >= optRangeSelected.min && city.population <= optRangeSelected.max)
    const populationOfCities = teaserCities.filter(city => city.population >= optRangeSelected.min)
    const eaps = populationOfCities.map(city => city.EAP)

    // return eaps.some(eap => eap >= optionToCheck.min && eap <= optionToCheck.max)
    return eaps.some(eap => eap < optionToCheck.max) && optionToCheck.min < optRangeSelected.min
}

export function getBorderCityOptions(popRangeSelected, eapRangeSelected, optionToCheck, teaserCities) {
    if (!popRangeSelected || !eapRangeSelected) return
    
    const popOptRangeSelected = OPTION_INFO.find(opt => opt.accessKey === "population").options.find(option => option.item === popRangeSelected)
    const eapOptRangeSelected = OPTION_INFO.find(opt => opt.accessKey === "eap").options.find(option => option.item === eapRangeSelected)

    const populationOfCities = teaserCities.filter(city => city.population >= popOptRangeSelected.min)
    // const populationOfCitie = teaserCities.filter(city => city.population >= popOptRangeSelected.min && city.population <= popOptRangeSelected.max)
    // const eapOfCities = populationOfCities.filter(city => city.EAP >= eapOptRangeSelected.in && city.EAP <= eapOptRangeSelected.max)
    const eapOfCities = populationOfCities.filter(city => city.EAP >= eapOptRangeSelected.min)

    return eapOfCities.some(city => BORDER_CITY_OPTIONS?.[optionToCheck.item]?.includes(city.datamexico_municipality_id))
}
